import { Stock } from "components/Stock/Stock.helper";
import { Link } from "react-router-dom";
import { useTableFilterQuery } from "components/Forms/TableFilter";
import './StockRow.css';
import classNames from "classnames";

type StockRowProps = { sector: string } & Stock;

export const StockRow = ({ symbol, krShortName, declineRate, trailingPE, forwardPE }: StockRowProps) => {
  const { data: filter } = useTableFilterQuery();
  const { fields } = filter || {};

  return (
    <li className={classNames("stock-row list-group-item", `fields-${fields}`)} style={{ "--decline-rate": `${(declineRate * -1).toFixed(1)}%` } as React.CSSProperties}>
      <Link to={`/stocks/${symbol}`} className="d-flex justify-content-between text-decoration-none text-body">
        <span>{krShortName}</span>
        {fields === 'trailing-pe' && <span>{trailingPE?.toFixed(1)}</span>}
        {fields === 'forward-pe' && <span>{forwardPE?.toFixed(1)}</span>}
        {fields === 'decline-rate' && <span>{declineRate.toFixed(1)}%</span>}
      </Link>
    </li>
  )
}
